import { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

let ctx;
const blip = (freq, vol = 0.05) => {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = "sine";
    o.frequency.setValueAtTime(freq, ctx.currentTime);
    o.frequency.exponentialRampToValueAtTime(freq * 1.4, ctx.currentTime + 0.08);
    g.gain.setValueAtTime(vol, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.14);
    o.connect(g).connect(ctx.destination);
    o.start();
    o.stop(ctx.currentTime + 0.15);
  } catch (err) {
    console.debug("SoundFX playback unavailable:", err);
  }
};

export const SoundFX = () => {
  const [on, setOn] = useState(() => localStorage.getItem("kr_sound") !== "off");

  useEffect(() => {
    localStorage.setItem("kr_sound", on ? "on" : "off");
    if (!on) return;
    const onClick = (e) => {
      const el = e.target.closest("a, button");
      if (!el || el.dataset.testid === "sound-toggle") return;
      blip(el.tagName === "A" ? 520 : 660);
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, [on]);

  const toggle = () => {
    setOn((v) => {
      if (!v) blip(760, 0.06);
      return !v;
    });
  };

  return (
    <button
      className="sound-toggle"
      onClick={toggle}
      aria-label={on ? "Mute interface sounds" : "Enable interface sounds"}
      title={on ? "Sounds on" : "Sounds off"}
      data-testid="sound-toggle"
    >
      {on ? <Volume2 size={17} /> : <VolumeX size={17} />}
    </button>
  );
};
